<script>

import pagination from "@/mixins/pagination";
import tableSearch from "@/mixins/tableSearch";
import CommonTableComponent from "@/components/table.vue";
import apiEndpoints from "@/services/apiEndpoints";

export default {
  components: {
    CommonTableComponent
  },
  mixins: [pagination, tableSearch],
  props: ['dataSearch','caseId','errorValid'],
  data() {
    return {
      isLoading: false,
      listWorkOrder: [],
      showModal: false,
      filters: {
        searchValue: '',
        column: "id",
        dir: "ASC",
      }
    };
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const url = this.caseId ? apiEndpoints.popup_search_work_order_by_case(this.caseId) : apiEndpoints.popup_search_work_order_all
      const {status, data} = await this.$http.get(url, this.filters)
      this.isLoading = false;
      if (status) {
        const result = data.result;
        this.listWorkOrder = this.$_.isEmpty(result) ? [] : result;
      }
    },
    updateValue: function (value) {
      this.dataSearch.work_order_name = value;
      this.$emit('dataSelected', this.dataSearch)
      this.closeModal();
    },
    openModal() {
      this.getData()
      this.showModal = true
    },
    closeModal() {
      this.showModal = false;
    },
    performDebounceSearch() {
      this.resetToFirstPage();
      this.updateUrlFilters();
    },
    updateUrlFilters() {
      this.getData()
    },
    isInputError(input){
      if (!this.errorValid) return false;

      return !!this.errorValid[input];
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "作業指示番号",
          value: "id",
          sortable: true,
          width:20
        },
        {
          text: "作業指示名",
          value: "work_orders_name",
          sortable: true,
        },
        {
          text: "商流名",
          value: "case_name",
          sortable: true,
        },
        {
          text: "作業分類",
          value: "work_order_type",
          sortable: true
        },
      ];
    },
    inputSearch: {
      get() {
        return this.dataSearch.work_order_name;
      },
      set(newValue) {
        this.dataSearch.work_order_name = newValue;
      }
    }
  },
};
</script>
<template>
  <b-row>
    <slot name="openBtn">
      <b-col align-self="center" cols="1">作業指示名</b-col>
      <b-col class="d-flex">
        <div class="w-100 me-2">
          <input
            type="text"
            class="form-control me-2"
            v-model="inputSearch"
            maxlength="256"
            :class="{
                'is-invalid': isInputError('work_order_name')
              }"
          />
          <div
            v-if="isInputError('work_order_name')"
            class="invalid-feedback"
          >
            {{ errorValid['work_order_name'][0] }}
          </div>
        </div>
        <b-button
          @click="openModal()"
          variant="outline-info"
          class="cus-h-btn"
        >
          <i class="bx bx-file-find"/>
        </b-button>
      </b-col>
    </slot>
    <Transition name="fade">
      <div v-if="showModal" class="position-absolute z-index" style="z-index: 1041;">
        <div class="modal d-block" aria-modal="true" @click.self="showModal = false">
          <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
              <header class="modal-header">
                <h5 class="modal-title font-18">作業指示一覧</h5>
                <button type="button" aria-label="Close" class="close" @click="showModal = false">×</button>
              </header>
              <div class="modal-body">
                <b-row>
                  <div>
                    <b-form-input
                      placeholder="フィルター..."
                      v-model="filters.searchValue"
                      v-on:keyup.enter="performDebounceSearch"
                      type="text"
                    ></b-form-input>
                  </div>
                </b-row>
                <b-row class="mt-2">
                  <b-overlay
                    :show="isLoading"
                    rounded
                    opacity="0.6"
                    spinner-small
                    spinner-variant="primary"
                    class="d-inline-block"
                  >
                    <CommonTableComponent :height-class="`table-wrapper-500`">
                      <thead class="table-light">
                        <tr>
                          <th
                            v-for="item in headers"
                            :class="getHeaderClass(item)"
                          >
                            <span v-if="item.sortable" @click="clickSort(item.value)">
                              {{ item.text }}
                              <i :class="getSortClass(item.value)"></i>
                            </span>
                                    <span v-else>
                              {{ item.text }}
                            </span>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="workOrder in listWorkOrder"
                          class="cursor-pointer"
                          @click="updateValue(workOrder.name)"
                        >
                          <td>
                            {{ workOrder.id }}
                          </td>
                          <td>
                            {{ workOrder.name }}
                          </td>
                          <td>
                            {{ workOrder.case.case_name }}
                          </td>
                          <td>
                            {{ workOrder.work_order_type.work_order_type }}
                          </td>

                        </tr>
                        <tr v-if="!listWorkOrder.length && !isLoading">
                          <td :colspan="headers.length" class="text-center">
                            データなし。
                          </td>
                        </tr>
                      </tbody>
                    </CommonTableComponent>
                  </b-overlay>
                </b-row>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-backdrop"></div>
      </div>
    </Transition>
  </b-row>
</template>
<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
.cus-h-btn {
  max-height: 38px;
}
</style>
